module.exports = __webpack_public_path__ + "static/media/BAP3.0089e5d2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP3.png
 ** module id = 681
 ** module chunks = 0
 **/